<template>
  <div>
    <top />
    <div class="main home">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <span class="fl" style="line-height: 40px;margin-left:20px;">当前位置：</span>
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>诚聘英才</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <el-table :data="tableData" :header-row-class-name="tableRowClassName" style="width: 100%">
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-form label-position="left" inline class="demo-table-expand">
                <el-form-item label="职位名称：">
                  <span>{{ props.row.post }}</span>
                </el-form-item>
                <el-form-item label="岗位职责：">
                  <ul v-if="props.row.duty">
                    <li v-for="(item,index) in props.row.duty" :key="index">{{item.content}}</li>
                  </ul>
                  <ul v-else>
                    <li>暂无内容</li>
                  </ul>
                </el-form-item>
                <el-form-item label="任职条件：">
                  <ul v-if="props.row.duty">
                    <li v-for="(item,index) in props.row.condition" :key="index">{{item.content}}</li>
                  </ul>
                  <ul v-else>
                    <li>暂无内容</li>
                  </ul>
                </el-form-item>
                <a href="mailto:jianli@drcnet.com.cn">申请岗位</a>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column label="招聘岗位" prop="post"></el-table-column>
          <el-table-column label="招聘人数" prop="number"></el-table-column>
          <el-table-column label="最低学历要求" prop="education"></el-table-column>
          <el-table-column label="工作地点" prop="adress"></el-table-column>
        </el-table>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [
        {
          id: "1",
          post: "金融研究员",
          number: "1",
          education: "硕士",
          adress: "北京市东城区",
          duty: [
            { content: "1、承担国研网系列研究报告库的日常更新与维护" },
            { content: "2、撰写金融中国周度、月度、季度和年度分析报告；" },
            { content: "3、参与部门产品改进和创新工作；" },
            { content: "4、参与相关课题研究及个性化项目工作；" },
            { content: "5、协助落实其他临时事宜。" }
          ],
          condition: [
            {
              content:
                "1、硕士及以上研究生，本科和研究生均毕业于国内外知名高校，金融、经济等相关专业；"
            },
            {
              content: "2、应届毕业生及有工作经验候选人均可；"
            },
            {
              content:
                "3、熟悉金融行业，特别是在金融研究领域具有相关工作背景者优先，有金融方面研究成果（在核心期刊发表过文章）优先；"
            },
            {
              content:
                "4、具备较强的创新意识和独立研究能力，有良好的敬业精神和团队合作精神；"
            },
            {
              content: "5、具备较强的责任心和良好的职业道德。"
            }
          ]
        },
        {
          id: "2",
          post: "宏观研究员",
          number: "1",
          education: "硕士",
          adress: "北京市东城区",
          duty: [
            { content: "1、承担国研网系列研究报告库的日常更新与维护；" },
            { content: "2、撰写宏观金融领域热点问题深度研究报告；" },
            { content: "3、参与部门产品改进和创新工作；" },
            { content: "4、参与相关课题研究及个性化项目工作；" },
            { content: "5、协助落实其他临时事宜。" }
          ],
          condition: [
            {
              content:
                "1、硕士及以上研究生，本科和研究生均毕业于国内外知名高校，金融、经济等相关专业；"
            },
            {
              content: "2、应届毕业生及有工作经验候选人均可；"
            },
            {
              content:
                "3、熟悉宏观行业，特别是在宏观研究领域具有相关工作背景者优先，有宏观方面研究成果（在核心期刊发表过文章）优先；"
            },
            {
              content:
                "4、具备较强的创新意识和独立研究能力，有良好的敬业精神和团队合作精神；"
            },
            {
              content: "5、具备较强的责任心和良好的职业道德。"
            }
          ]
        },
        {
          id: "3",
          post: "编辑",
          number: "1",
          education: "本科",
          adress: "北京市东城区",
          duty: [
            { content: "1、负责国研网部分文献库内容编辑工作；" },
            { content: "2、参与公司微信公众号内容策划、编写及编辑工作；" },
            { content: "3、参与部门产品改进和创新工作；" },
            { content: "4、参与部门承接的个性化项目工作；" },
            { content: "5、协助落实其他临时事宜。" }
          ],
          condition: [
            {
              content:
                "1、金融、经济相关专业，全日制正规财经院校本科及以上学历；"
            },
            {
              content:
                "2、具有敏锐的信息洞察能力、较强的文字驾驭能力和沟通表达能力；"
            },
            {
              content:
                "3、具有优秀的学习能力、较强的创新意识、高度的责任感和敬业精神、良好的职业道德和团队合作精神；"
            },
            {
              content:
                "4、熟悉常规办公软件的使用，从事过网站编辑工作、有一定的新媒体编辑工作经验者优先。"
            }
          ]
        }
      ]
    };
  },
  methods: {
    tableRowClassName({ rowIndex }) {
      if (rowIndex === 0) {
        return "headerColor";
      }
      return "";
    }
  }
};
</script>

<style lang='scss' scoped>
.main {
  .el-breadcrumb {
    background: #f3f5f7;
    margin-top: 30px;
  }
  .el-breadcrumb__item {
    line-height: 40px;
  }
  .content {
    padding: 20px 0 60px;
    /deep/.el-table__expanded-cell {
      width: 100%;
      background: #f7f9fa;
      padding-left: 45px;
    }
    /deep/.el-form-item {
      display: block;
    }
    /deep/.el-form-item:nth-child(2) {
      display: block;
    }
    /deep/ .headerColor {
      color: #1a1a1a;
    }
    /deep/.el-table__body-wrapper .el-table_1_column_2 {
      font-size: 14px;
      font-weight: bold;
      color: #1967b6;
    }
    span {
      font-size: 12px;
      font-weight: bold;
      color: #4d4d4d;
      line-height: 36px;
    }
    ul {
      li {
        font-size: 12px;
        font-weight: 400;
        color: #4d4d4d;
        line-height: 40px;
      }
    }
    a {
      display: block;
      width: 78px;
      height: 30px;
      background: #1967b6;
      font-size: 12px;
      font-weight: 400;
      color: #ffffff;
      line-height: 30px;
      text-align: center;
      margin: 28px 0;
    }
  }
}
</style>